import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { getBookLinks, getPrimaryNavLinks, getSecondaryNavLinks } from './navlinks';
var trPrimaryNav = getPrimaryNavLinks(['Çalışma', 'Görevler', 'Ödev yardımı', 'Konuları anla', 'Yazma ve alıntılar', 'Araçlar', 'Uzmanlarla Soru-Yanıt', 'Ders Kitabı Çözümleri', 'Matematik Çözücü', 'Alıntılar', 'İntihal denetleyicisi', 'Dil bilgisi denetleyicisi', 'Uzmanlarca metin düzeltme', 'Kariyer', 'Eğitim kampları', 'Kariyer tavsiyesi', 'Öğrenme Laboratuvarı']);
var trSecondaryNav = getSecondaryNavLinks(['Eğitimciler için', 'Yardım', 'Oturum aç']);
var trBooks = getBookLinks(['Kitaplar', 'Kirala/Satın al', 'Oku', 'İade et', 'Sat']);
export var turkishContentIntl = {
  PrimaryNav: trPrimaryNav,
  SecondaryNav: trSecondaryNav,
  experimentIds: []
};
export var turkishContentUS = {
  PrimaryNav: [trBooks].concat(_toConsumableArray(trPrimaryNav)),
  SecondaryNav: trSecondaryNav,
  experimentIds: []
};